// removed by extract-text-webpack-plugin
module.exports = {"container":"_2_wC08vDZCZH9o_aavxydS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/notFound/notFound.css
// module id = 503
// module chunks = 0